var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.locale === 'zh-CN')?_c('div',[_c(_setup.ZH)],1):_c('div',[_c(_setup.EN)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }